import { List, Table } from "antd";

export const InstancePool = ({ pool }) => {
  if (!pool) return <></>;

  // const columns = [
  //   {
  //     title: "Key",
  //     dataIndex: "key",
  //     key: "key",
  //   },
  //   {
  //     title: "Value",
  //     dataIndex: "value",
  //     key: "value",
  //   },
  // ];

  // const dataSource = Object.entries(JSON.parse(pool)).map(([key, value]) => ({
  //   key,
  //   value,
  // }));

  const content = pool ? Object.entries(JSON.parse(pool)).map(([key, value]) => (
    <>
      <strong>{key}:</strong>
      <span style={{ paddingLeft: "5px" }}>{value}</span>
    </>
  )): {};

  return (
    <div style={{ display: "flex", gap: "15px" }}>
      {content.map((item, index) => (
        <div key={index}>{item}</div>
      ))}
    </div>
  );
  // <List
  //   bordered
  //   dataSource={Object.entries(JSON.parse(pool))}
  //   renderItem={([key, value]) => (
  //     <List.Item>
  //       <strong>{key}:</strong> {value}
  //     </List.Item>
  //   )}
  // />
  // <Table dataSource={dataSource} columns={columns} pagination={false} />
};
